import { createAction } from 'redux-actions';
import {
	GET_IS_REFRESH_QR_CODE_EXISTS_CALL,
	GET_IS_REFRESH_QR_CODE_EXISTS_DONE,
	GET_IS_REFRESH_QR_CODE_EXISTS_FAIL,
	GET_REFRESH_QR_CODE_CALL,
	GET_REFRESH_QR_CODE_DONE,
	GET_REFRESH_QR_CODE_FAIL,
} from '../types/qrcode';

export const getRefreshQRCodeCall = createAction(GET_REFRESH_QR_CODE_CALL);
export const getRefreshQRCodeDone = createAction(GET_REFRESH_QR_CODE_DONE);
export const getRefreshQRCodeFail = createAction(GET_REFRESH_QR_CODE_FAIL);

export const getIsRefreshQRCodeExistsCall = createAction(GET_IS_REFRESH_QR_CODE_EXISTS_CALL);
export const getIsRefreshQRCodeExistsDone = createAction(GET_IS_REFRESH_QR_CODE_EXISTS_DONE);
export const getIsRefreshQRCodeExistsFail = createAction(GET_IS_REFRESH_QR_CODE_EXISTS_FAIL);
